
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1650505788843",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "6705",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M477.866667 337.493333h68.266666v285.866667h-68.266666z",
        "fill": "#ffffff",
        "opacity": ".99",
        "p-id": "6706"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 230.4m-119.466667 0a119.466667 119.466667 0 1 0 238.933334 0 119.466667 119.466667 0 1 0-238.933334 0Z",
        "fill": "#ffffff",
        "opacity": ".99",
        "p-id": "6707"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M221.866667 793.6m-119.466667 0a119.466667 119.466667 0 1 0 238.933333 0 119.466667 119.466667 0 1 0-238.933333 0Z",
        "fill": "#ffffff",
        "opacity": ".99",
        "p-id": "6708"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M802.133333 793.6m-119.466666 0a119.466667 119.466667 0 1 0 238.933333 0 119.466667 119.466667 0 1 0-238.933333 0Z",
        "fill": "#ffffff",
        "opacity": ".99",
        "p-id": "6709"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 793.6m-119.466667 0a119.466667 119.466667 0 1 0 238.933334 0 119.466667 119.466667 0 1 0-238.933334 0Z",
        "fill": "#ffffff",
        "opacity": ".99",
        "p-id": "6710"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M256 520.533333h512v102.4h68.266667v-119.466666c0-28.16-23.04-51.2-51.2-51.2H238.933333c-28.16 0-51.2 23.04-51.2 51.2v119.466666h68.266667v-102.4z",
        "fill": "#ffffff",
        "opacity": ".99",
        "p-id": "6711"
      }
    }
  ]
})
    }
  